
export const budgetbasic = {

  budgetcycle: {
    service: {
      name: 'budgetcycle',
      title: 'Budget Cycle',
    }
  },

  budgetstate: {
    service:{
      name:'budgetstate',
      title:'Budget State',
    }
  },

  budgettype: {
    service:{
      name:'budgettype',
      title:'Budget Type', 
    }
  },

  lineitemstate: {
    service:{
      name:'lineitemstate',
      title:'Lineitem State', 
    }
  },

  transactionstate: {
    service:{
      name:'transactionstate',
      title:'Transaction State',
    }
  },

  transactiontype: {
    service:{
      name:'transactiontype',
      title:'Transaction Type',
    }
  },

};
